import { PdfViewer } from '@/components/pdf-viewer'

import type { ResourceType } from '@/types/resource.type'

export function PdfContentViewer({
  resource,
  isDownloadable = false,
}: {
  resource: ResourceType
  isDownloadable?: boolean
}) {
  return <PdfViewer sourceUrl={resource.url} title={resource.fileName} isDownloadable={isDownloadable} />
}
